import {
  EQUIPMENT,
  getEquipmentFiltersExercisesSelect
} from '@gymaholic/packages'
import { invertObjectUtil } from 'packages/src'

export default function handleEquipmentSyncReduxToUrlAction ({
  searchParamsStr
}) {
  return (dispatch, getState) => {
    const equipmentFilters = getEquipmentFiltersExercisesSelect(getState())

    if (!equipmentFilters.length) {
      return searchParamsStr
    }

    let equipmentQueryParam = ''
    const EQUIPMENT_TO_KEY = invertObjectUtil(EQUIPMENT)
    equipmentFilters.map((equipmentId, index) => {
      const equipmentName = EQUIPMENT_TO_KEY[equipmentId].toLowerCase().replace(/_/g, ' ')
      if (index === 0) {
        equipmentQueryParam = equipmentQueryParam + equipmentName
      } else {
        equipmentQueryParam = equipmentQueryParam + `,${equipmentName}`
      }
      return null
    })

    if (searchParamsStr.length > 0) {
      return searchParamsStr + `&equipment=${equipmentQueryParam}`
    }

    return searchParamsStr + `equipment=${equipmentQueryParam}`
  }
}
